import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import { underscore } from '@ember/string';

interface AditoolsMenuLinkSignature {
  Element: HTMLLIElement;
  Args: {
    label: string;
    qaName?: string;
    svg?: string;
    icon?: string;
    onOpen?: () => void;
    onClose?: () => void;
    onSubmit?: () => void;
  };
  Blocks: {
    default: [
      {
        close: () => void;
        submit: () => void;
      }
    ];
  };
}
type AditoolsMenuLinkArgs = AditoolsMenuLinkSignature['Args'];

export default class AditoolsMenuLink extends Component<AditoolsMenuLinkSignature> {
  @tracked menuLinkEnabled = false;
  @tracked litUp = false;

  constructor(owner: unknown, args: AditoolsMenuLinkArgs) {
    super(owner, args);
    assert('`label` is required', !isNone(this.args.label));
    assert('Either `svg` or `icon` is required', !isNone(this.args.icon) || !isNone(this.args.svg));
  }

  get qaLinkName() {
    return this.args.qaName || underscore(this.args.label.toLowerCase());
  }

  get hasSVG(): boolean {
    return !isNone(this.args.svg);
  }

  get activeIcon() {
    return `${this.args.icon}-active-icon-md`;
  }

  get inactiveIcon() {
    return `${this.args.icon}-inactive-icon-md`;
  }

  @action closeLink() {
    if (this.args.onClose) {
      this.args.onClose();
    }
    this.menuLinkEnabled = false;
  }

  @action submitLink() {
    if (this.args.onSubmit) {
      this.args.onSubmit();
    }
    this.litUp = true;
    this.menuLinkEnabled = false;
  }

  @action clicked(/*_evt: MouseEvent*/) {
    if (this.args.onOpen) {
      this.args.onOpen();
    }
    this.menuLinkEnabled = true;
  }

  @action keyPressed(evt: KeyboardEvent) {
    if (['Enter', ' '].includes(evt.key)) {
      if (this.args.onOpen) {
        this.args.onOpen();
      }
      this.menuLinkEnabled = true;
    }
  }

  @action mouseEntered(/*_evt: MouseEvent*/) {
    this.litUp = true;
  }

  @action mouseLeft(/*_evt: MouseEvent*/) {
    this.litUp = false;
  }
}
